// Rutas de las pantallas. Arriba del menú, el uso diario (dashboard, clientes,
// conciliar); al pie, la configuración y la sincronización con ARCA.
export const RUTAS = {
  inicio: '/inicio',
  clientes: '/clientes',
  cliente: (id: number) => `/clientes/${id}`,
  conciliar: '/conciliar',
  cumplimiento: '/cumplimiento',
  bandeja: '/bandeja',
  vencimientos: '/vencimientos',
  configUsuarios: '/config/usuarios',
  configUsuario: (id: number) => `/config/usuarios/${id}`,
  configClientes: '/config/clientes',
  configClienteNuevo: '/config/clientes/nuevo',
  configCliente: (id: number, pestana?: string) => `/config/clientes/${id}${pestana ? `?pestana=${pestana}` : ''}`,
  configDocumentos: '/config/documentos',
  sincronizacion: '/sincronizacion',
  miCuenta: '/mi-cuenta',
  ayuda: '/ayuda',
} as const;
